import React from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export const Team = (props) => {
  return (
    <div id="team" className="text-center container">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>Nuestros clientes</h2>
      </div>
      <div>
        <div
          id="carousel-example-generic"
          className="carousel slide"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            <li
              data-target="#carousel-example-generic"
              data-slide-to="0"
              className="active"
            ></li>
            <li data-target="#carousel-example-generic" data-slide-to="1"></li>
            <li data-target="#carousel-example-generic" data-slide-to="2"></li>
          </ol>
          <div className="carousel-inner" role="listbox">
            <div className="item active" id="row">
              <img
                src="img/team/01.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/02.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/03.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/04.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
            </div>
            <div className="item">
              <img
                src="img/team/05.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/06.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/07.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/08.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
            </div>
            <div className="item">
              <img
                src="img/team/09.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/10.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/11.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/12.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
            </div>
            <div className="item">
              <img
                src="img/team/13.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/14.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/15.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
              <img
                src="img/team/16.jpg"
                class="img-responsive"
                alt="Responsive image"
              />
            </div>
          </div>
          <a
            class="left carousel-control buttonArrow"
            href="#carousel-example-generic"
            role="button"
            data-slide="prev"
          >
            <span className="spanArrow" >
              <ArrowBackIos/>
            </span>
            <span class="sr-only">Previous</span>
          </a>
          <a 
            class="right carousel-control buttonArrow"
            href="#carousel-example-generic"
            role="button"
            data-slide="next"
          >
            <span className="spanArrow">
              <ArrowForwardIos/>
            </span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  );
};
